import { Flex, Tooltip } from "antd";
import cn from "classnames";
import { memo } from "react";
import { useIntl } from "react-intl";
import Algorithm from "../Algorithm/Algorithm";
import { Select } from "../Select/Select";
import Status from "../Status/Status";
import Pools from "./Pools/Pools";
import styles from "./PoolSelector.module.scss";
import { IPoolSelectorProps } from "./PoolSelector.props";
import { usePoolSelectorControl } from "./usePoolSelectorControl";

function PoolSelector(props: IPoolSelectorProps) {
  const {
    name,
    oldValue,
    hasPrevValue,
    id,
    userOptions,
    hasCleanUp,
    className,
    showPoolData,
  } = props;
  const { formatMessage } = useIntl();
  const control = usePoolSelectorControl(props);

  const showClearIcon =
    hasCleanUp && control.value?.name !== formatMessage({ id: "selector.all" });

  const hasPoolValue =
    showPoolData && control?.value?.id && control?.value?.Pools?.[0];

  const options = (
    (control.me?.settings || []).map((option, i) => ({
      label: option.name,
      value: option.id,
      render: (
        <Algorithm
          iconSize={16}
          algo={option.hash}
          className={cn(styles.selector, styles.item, styles.algo)}
          hashName={option.name}
          login={option?.Pools?.[0]?.login}
          normalizeCase
        />
      ),
    })) || []
  ).concat(
    (userOptions?.length && [
      {
        label: "",
        value: -1,
        render: (
          <span>
            {props.userEmail ||
              formatMessage({ id: "change_setting.user_pools" })}
          </span>
        ),
      },
      ...(userOptions || []).map((option, i) => ({
        label: option.name,
        value: option.id,
        render: (
          <Algorithm
            iconSize={16}
            algo={option.hash}
            className={cn(styles.selector, styles.item, styles.algo)}
            hashName={option.name}
            login={option?.Pools?.[0]?.login}
            normalizeCase
          />
        ),
      })),
    ]) ||
    []
  );

  return (
    <Select
      disabled={props.disabled}
      wrapClassName={className}
      size="small"
      onChange={(value) => {
        let item = control.me?.settings.find((item) => item.id === value);
        if (!item) {
          item = userOptions?.find((item) => item.id === value);
        }
        if (item) {
          control.onSelect(item);
        }
      }}
      onClear={control.onReset}
      allowClear={showClearIcon}
      id={id}
      value={control.value?.id}
      label={
        <Flex align="center" justify="space-between">
          <span className={styles.label}>{name}</span>
          {hasPoolValue && control.value?.Pools[0].status !== undefined && (
            <Tooltip
              trigger={"click"}
              placement="right"
              color="#fff"
              title={<Pools pools={control.value.Pools} />}
              destroyOnHidden
            // destroyTooltipOnHide
            // overlayInnerStyle={{ width: 400, maxWidth: 400 }}
            >
              <div>
                <Status status={control.value?.Pools[0].status === 1 ? 0 : 8} />
              </div>
            </Tooltip>
          )}
        </Flex>
      }
      optionRender={(option) =>
        options.find((item) => `${item.value}` === `${option.value}`)?.render
      }
      options={options.map((item) => ({
        label: item.label,
        value: item.value,
        disabled: !item.value,
      }))}
    />
  );
}

export default memo(PoolSelector);
